import { Link } from 'react-router-dom'
import { useReveal } from '@/hooks/useReveal'
import { SITE, STATS } from '@/data/site'

export function Hero() {
  const revealRef = useReveal<HTMLElement>()

  return (
    <section className="hero" ref={revealRef}>
      <div className="hero-bg" aria-hidden="true">
        <div className="hero-orb hero-orb-1" />
        <div className="hero-orb hero-orb-2" />
        <div className="hero-grid" />
      </div>

      <div className="container hero-inner">
        <div className="hero-content">
          <span className="hero-badge reveal">专业增值电信业务服务商</span>
          <h1 className="hero-title reveal delay-1">
            专业增值电信，
            <br />
            可靠<span className="gradient-text">互联服务</span>
          </h1>
          <p className="hero-desc reveal delay-2">{SITE.description}</p>
          <div className="hero-actions reveal delay-3">
            <Link to="/about" className="btn btn-primary btn-lg">
              了解我们
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>
            </Link>
            <Link to="/services" className="btn btn-ghost btn-lg">
              了解核心服务
            </Link>
          </div>
          <div className="hero-stats reveal delay-4">
            {STATS.map((s) => (
              <div key={s.label} className="hero-stat">
                <strong>{s.value}</strong>
                <span>{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="hero-visual reveal delay-2" aria-hidden="true">
          <div className="hero-card hero-card-main">
            <div className="hero-card-dots">
              <span /><span /><span />
            </div>
            <div className="hero-card-title">增值电信业务服务</div>
            <ul className="hero-feature-list">
              <li><span className="float-icon">✓</span> 持证经营，依法合规</li>
              <li><span className="float-icon">✓</span> 互联网信息服务</li>
              <li><span className="float-icon">✓</span> 在线数据处理与交易</li>
              <li><span className="float-icon">✓</span> 稳定可靠的运维支持</li>
            </ul>
            <div className="hero-card-footer">
              <div className="hero-card-metric">
                <span>服务对象</span>
                <strong>企业客户</strong>
              </div>
              <div className="hero-card-tag">合规 · 可靠</div>
            </div>
          </div>
          <div className="hero-card hero-card-float">
            <span className="float-icon">✓</span>
            <div>
              <strong>资质齐全</strong>
              <span>增值电信业务经营</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
